// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper---VP8h","inner":"index-module--inner--2Bd8L"};